import { PRODUCT_INFO_LINK } from "constant";
import React, { Component } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";

interface State {
    hasError: boolean;
    pathname?: string;
}

class ErrorBoundary extends Component<React.PropsWithChildren<any>, State> {
    public state: State = {
        hasError: false,
    };

    public static getDerivedStateFromProps(
        props: React.PropsWithChildren<any>,
        state: State
    ) {
        if (globalThis.location.pathname !== state.pathname) {
            return { hasError: false, pathname: globalThis.location.pathname };
        }

        return {};
    }

    public static getDerivedStateFromError(_: Error): State {
        return { hasError: true, pathname: globalThis.location.pathname };
    }

    public render() {
        if (this.state.hasError) {
            return (
                <div className="page-content">
                    <Container fluid>
                        <Row>
                            <Col sm="12" className="mt-2">
                                <div className="empty-widget p-5">
                                    <h3>Something went wrong.</h3>
                                    <p>
                                        If the problem persists, please contact
                                        support at{" "}
                                        <a
                                            target="_blank"
                                            href={PRODUCT_INFO_LINK}
                                            rel="noreferrer"
                                        >
                                            {PRODUCT_INFO_LINK}
                                        </a>
                                    </p>
                                    <Button
                                        className="mt-2 mb-2"
                                        onClick={() => {
                                            globalThis.location.reload();
                                        }}
                                    >
                                        Reload
                                    </Button>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
